import { Component, OnInit } from '@angular/core';
import { User, UserRegistrationModel, UserType, PostUserType,PostLocationsModel } from '../models/user.model';
import { AnonymousSubscription } from 'rxjs/Subscription';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { NgForm } from '@angular/forms';
import { LookupService } from '../services/lookups/lookup.service';
import { RegistrationService } from '../services/registration.service';
import { ReportCategory, UserReportCategory } from '../models/report.model';
import { NotifierService } from 'angular-notifier';
//import { enableDebugTools } from '@angular/platform-browser';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  currentUser: User;
  userLocations: PostLocationsModel[];
  rootLocations: Location[];
  userCategories: UserReportCategory[];
  postEmployments: PostUserType[] = [];
  postEmployment: PostUserType;
  registerUserModel: UserRegistrationModel;
  private isButtonVisible = true;
  oldLocation: number = 0;
  //postuser: any;

  constructor(
    private authUser: AuthUserService,
    private lookupService: LookupService,
    private registrationService: RegistrationService,
    private notifier: NotifierService
  ) {}

  ngOnInit() {
    this.currentUser = this.authUser._user;
    // Post User Types -- LES or FSO
    this.postEmployments.push(new PostUserType(0, 'Post Type', 'Select Post Type'));
    this.postEmployments.push(new PostUserType(1, 'LES', 'Locally Employed Staff (LES)'));
    this.postEmployments.push(new PostUserType(2, 'FSO', 'Foreign Service Officer (FSO)'));
    if (this.currentUser.userLocations.length === 0) {
      this.postEmployment = this.postEmployments.find(p => p.id === 0);
    } else {
      if (this.currentUser.isLes === true) {
        this.postEmployment = this.postEmployments.find(p => p.id === 1);
      } else {
        this.postEmployment = this.postEmployments.find(p => p.id === 2);
      }
    }
    this.getUserLocations();
    this.getUserReportCategories();
    this.currentUser.userRoleId = Array<number>();
    this.lookupService.getRootLocations(this.currentUser.userType.typeName).subscribe((data: Location[]) => {
      this.rootLocations = data.sort(
        (a, b): number => {
          if (a.toString < b.toString) return -1;
          if (a.toString > b.toString) return 1;
          return 0;
        }
      );
    });
  }

  //RegisterUser;
  getUserLocations() {
    this.lookupService.getUserLocations().subscribe((locations: any[]) => {
      // console.log(locations);
      this.userLocations = locations.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
      if (this.userLocations.length > 0) this.isButtonVisible = false;
      else this.isButtonVisible = true;
    });
  }

  deleteUserLocation(locationId: number) {
    // console.log(locationId);
    this.registrationService.deleteUserLocation(locationId).subscribe(resp => {
      if (resp.ok) {
        this.notifier.notify('success', 'User Location deleted successfully');
        //this.authUser._user.userLocations[0].locationId;

        this.getUserLocations();
        this.authUser.getAuthUser();
      }
    });
  }

  onSavePostType() {
    let SelectedUserType = new UserType();
    SelectedUserType.id = this.postEmployment.id;
    SelectedUserType.typeName = this.postEmployment.typeName;
    this.currentUser.userRoleId = [];
    if (this.postEmployment.typeName == 'Post Type') {
      this.notifier.notify('error', 'Please select a Post Type and Save to Proceed');
    } else {
      if (this.postEmployment.typeName == 'LES') {
        this.currentUser.isLes = true;
        this.currentUser.userRoleId.push(3);
        //Check If RolID 3 is present if not add
        //If RoleID 4 is present then delete
      } else if (this.postEmployment.typeName == 'FSO') {
        this.currentUser.isLes = false;
        this.currentUser.userRoleId.push(3);
        this.currentUser.userRoleId.push(4);
        //Check if 3 is present if not add 3
        //Check if 4 is present if not add 4
      }
      this.isButtonVisible = false;

      this.registrationService.updateUser(this.currentUser).subscribe(resp => {
        if (resp.ok) {
          this.authUser.getAuthUser();
           this.notifier.notify('success', 'Post Type saved successfully');
        }
      });
    }
  }

  SaveReportingStations(newLocationIds: number[]) {
    this.userLocations.forEach(userlocation => {newLocationIds.forEach(newLocationId => {
        if(newLocationId === userlocation.postId)
                  this.oldLocation++;
      });     });
    this.registrationService.addUserLocations(newLocationIds).subscribe(resp => {
      if (resp.ok) {
        if(this.oldLocation != 0)
          this.notifier.notify('error', 'One or more Locations already exists in your Profile');
        if(newLocationIds.length > this.oldLocation)
          this.notifier.notify('success', 'User Locations saved successfully');
        this.getUserLocations();
        this.authUser.getAuthUser();
        this.oldLocation = 0;
      }
    });
  }

  getUserReportCategories() {
    this.lookupService.getUserCategories().subscribe((userCategories: UserReportCategory[]) => {
      // console.log(userCategories);
      this.userCategories = userCategories.sort(
        (a, b): number => {
          if (a.categoryName < b.categoryName) return -1;
          if (a.categoryName > b.categoryName) return 1;
          return 0;
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/user-profile/user-profile.component.ts